import { getGFT, postGFT } from '@/common/utils/ajax'
const getRateData = () => {
    return getGFT('v1/bank_interest_rates')
}

const getLoansHistory = (params) => { return getGFT('v1/user_house_loans', params) }

const setLoans = (params) => postGFT(`v1/user_house_loans`, params)

export default {
    setLoans,
    getLoansHistory,
    getRateData
}